"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Guid = void 0;
const guid_typescript_1 = require("guid-typescript");
function Guid(length, noDash) {
    if (!length)
        length = 1;
    let uuid = '';
    for (var i = 0; i < length; i++) {
        uuid += guid_typescript_1.Guid.create().toString();
    }
    if (noDash) {
        return uuid.delete('-');
    }
    else {
        return uuid;
    }
}
exports.Guid = Guid;
